export default __webpack_public_path__ + "static/splash-76c78a2b6b1b42b6e5e65d76be728522.svg";